import { RateProviderDetails } from './RateProviderDetails';

export class DATRateProviderDetails implements RateProviderDetails {
  reports?: number;
  companies?: number;
  timeframe?: string;
  origin?: string;
  destination?: string;

  constructor(opts?: Partial<DATRateProviderDetails>) {
    if (opts?.reports != null) {
      this.reports = opts.reports;
    }
    if (opts?.companies != null) {
      this.companies = opts.companies;
    }
    if (opts?.timeframe != null) {
      this.timeframe = opts.timeframe;
    }
    if (opts?.origin != null) {
      this.origin = opts.origin;
    }
    if (opts?.destination != null) {
      this.destination = opts.destination;
    }
  }
}
